import { brandColors } from 'shared/basicPalette'
import tinycolor from 'tinycolor2'

export function getRgbFromHex(hexColor: string) {
  // remove # if exists
  if (hexColor.substr(0, 1) === '#') {
    hexColor = hexColor.substr(1, hexColor.length)
  }
  const r = parseInt(hexColor.substr(0, 2), 16)
  const g = parseInt(hexColor.substr(2, 2), 16)
  const b = parseInt(hexColor.substr(4, 2), 16)
  return { r, g, b }
}

export function generatePalette(baseColorHex: string, midColorIndex: number) {
  const arr = generateShadesPalette(baseColorHex)
  return {
    50: arr[9],
    100: arr[8],
    200: arr[7],
    300: arr[6],
    400: arr[5],
    500: arr[4], // usually minimum contract for the smaller texts
    600: arr[3],
    700: arr[2],
    800: arr[1],
    900: arr[0],
    mid: arr[midColorIndex],
    default: baseColorHex
  }
}

/**
 * Generate RGBA string from HEX and alpha channel
 * @param hexColor
 * @param alpha
 */
export function getRgbaFromHex(hexColor: string, alpha: number) {
  const { r, g, b } = getRgbFromHex(hexColor)
  return `${r}, ${g}, ${b}, ${alpha}`
}

/**
 * Recognise if color is dark then threshold
 * @param hexColor
 * @returns
 */
export function isColorDark(hexColor?: string | null) {
  if (!hexColor) {
    return false
  }
  const { r, g, b } = getRgbFromHex(hexColor)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  const threshold = 190 // 128 original
  return yiq < threshold
}

/**
 * Use to set correct contrast color for headers and such
 */
export function getTextClassForColor(hexColor?: string | null) {
  return isColorDark(hexColor) ? 'text-white' : 'text-dark'
}
export function getTextColor(organisation) {
  return organisation.styles?.colors?.navbarLink
    ? organisation.styles.colors.navbarLink
    : isColorDark(getBackgroundColor(organisation))
    ? brandColors.white
    : brandColors.grey.dark
}

export function getBackgroundColor(organisation) {
  return organisation.styles?.colors?.navbarBackground
    ? organisation.styles.colors.navbarBackground
    : brandColors.green.mid
}

/**
 * Generate 10color shade palette from HEX color
 * @param hexColor
 * @returns
 */
export function generateShadesPalette(hexColor: string) {
  let palette: string[] = []

  const color = tinycolor(hexColor)
  const stepCount = 10
  const darknessCorrection = 3
  const stepsToDark =
    Math.round(color.getLuminance() * stepCount) + darknessCorrection
  const stepsToLight = stepCount - stepsToDark
  const shadeRatio = 10

  for (let i = stepsToDark; i >= 0; i--) {
    palette.push(
      color
        .clone()
        .darken(i * shadeRatio)
        .toString()
    )
  }
  for (let i = 1; i <= stepsToLight; i++) {
    palette.push(
      color
        .clone()
        .lighten(i * shadeRatio)
        .toString()
    )
  }
  return palette
}

export const rgba = (hex: string, alpha: number) => {
  const { r, g, b } = getRgbFromHex(hex)
  return `${r}, ${g}, ${b}, ${alpha}`
}
